export const guestTemplates = {
  friendly: ({ title, date, time, location, host, link, userCode }) =>
    `
Hello Guest,

We’re excited to invite you to ${title}

${date ? `Date: ${date}` : ""}${time ? `\nTime: ${time}` : ""}${
      location ? `\nVenue: ${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nInvite Code: ${userCode}` : ""}

To RSVP, simply click on the link below to download the NimbleBash App, and enter the invite code above

${link}

We can’t wait to see you there!
`.trim(),
  formal: ({ title, date, time, location, host, link, userCode }) =>
    `
Dear Guest,

You are warmly invited to attend ${title}.

${date ? `Date: ${date}` : ""}${time ? `\nTime: ${time}` : ""}${
      location ? `\nVenue: ${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nInvite Code: ${userCode}` : ""}


To RSVP, simply click on the link below to download the NimbleBash App, and enter the invite code above

${link}

We look forward to welcoming you.

`.trim(),

  casual: ({ title, date, time, location, host, link, userCode }) =>
    `
Hey Guest!

You’re invited to ${title}

${date ? `${date}` : ""}${time ? `\n${time}` : ""}${
      location ? `\n${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nInvite Code: ${userCode}` : ""}

To RSVP, simply click on the link below to download the NimbleBash App, and enter the invite code above

${link}

Can’t wait to see you there!

`.trim(),
};

export const usherTemplates = {
  friendly: ({ title, date, time, location, host, link, userCode }) =>
    `
Hello Usher,

We’re super excited to have you on board as an usher/volunteer for ${title}!

${date ? `Date: ${date}` : ""}${time ? `\nTime: ${time}` : ""}${
      location ? `\nVenue: ${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nUsher Code: ${userCode}` : ""}

Your main role will be to check in guests at the entrance by scanning their QR codes and helping make the event experience smooth and fun for everyone!

Click below to confirm your spot:

${link}
`.trim(),

  formal: ({ title, date, time, location, host, link, userCode }) =>
    `
Hello Usher,

We are pleased to invite you to serve as an usher at the upcoming ${title}.

${date ? `Date: ${date}` : ""}${time ? `\nTime: ${time}` : ""}${
      location ? `\nVenue: ${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nUsher Code: ${userCode}` : ""}

Your primary responsibility will be to check in guests at the event entrance by scanning their QR codes to ensure an efficient and well-organized entry process.

Please confirm your participation by clicking the link below:

${link}
`.trim(),

  casual: ({ title, date, time, location, host, link, userCode }) =>
    `
Hey Usher!

You’re invited to be part of the ${title} crew as an usher!

${date ? `${date}` : ""}${time ? `\n${time}` : ""}${
      location ? `\n${location}` : ""
    }${host ? `\nHost: ${host}` : ""}${userCode ? `\nUsher Code: ${userCode}` : ""}

Your job? Just help check in guests by scanning their QR codes at the entrance — easy and super important!

Join the team here:

${link}
`.trim(),
};
